exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".TextBox__root input.TextBox__isSearch{padding-left:2.5em}\n", "", {"version":3,"sources":["/home/runner/work/gl-web-react-ui/gl-web-react-ui/web/js/components/common/TextBox/TextBox.scss"],"names":[],"mappings":"AAAA,uCAAqB,kBAAkB,CAAC","file":"TextBox.scss","sourcesContent":[".root input.isSearch{padding-left:2.5em}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "TextBox__root",
	"isSearch": "TextBox__isSearch"
};